module.exports = __webpack_public_path__ + "ipetbooking/admin/img/atm.219cf93c.svg";